import { Tooltip, Badge } from 'appkit-react';

import { ReconStatusTypeEnum } from '../../../../constants';

const getBadgeType = status => {
    let type;
    switch (status) {
        case ReconStatusTypeEnum.SUCCESS:
            type = 'success';
            break;
        case ReconStatusTypeEnum.INPROGRESS:
            type = 'warning';
            break;
        case ReconStatusTypeEnum.NOTSTARTED:
            type = 'secondary';
            break;
        default:
            type = 'error';
            break;
    }
    return type;
};

const StatusBadge = ({
    data, navigateToReconResult, history, tenantId,
}) => (
    <>
        {(data.reconRunStatus === ReconStatusTypeEnum.SUCCESS)
            && (
                <Tooltip content={`${data.reconRunStatus === ReconStatusTypeEnum.SUCCESS ? 'View Results' : ''}`} placement="left" tooltipTheme="light">
                    <Badge
                        className="cursor-pointer"
                        type={getBadgeType(data.reconRunStatus)}
                        onClick={() => {
                            navigateToReconResult(history, data, tenantId);
                        }}
                    >
                        <span>{ReconStatusTypeEnum.COMPLETE}</span>
                    </Badge>
                </Tooltip>
            )}

        {(data.reconRunStatus !== ReconStatusTypeEnum.SUCCESS)
            && (
                <Badge
                    type={getBadgeType(data.reconRunStatus)}
                >
                    <span>{data.reconRunStatus}</span>
                </Badge>
            )}
    </>
);

export default StatusBadge;
